import React from 'react';
import { captureError, sentry } from '../utils/errorReporter';
import { InitErrorMessage } from './CashierPaymentsWidget/elements';

export class ErrorBoundary extends React.Component<
  { isModalTheme: boolean; onCatch(): void },
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    sentry.withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key]);
      });

      // NOTE: In development mode, React will rethrow errors caught within an error boundary.
      // This will result in errors being reported twice to Sentry with the above setup, but this won’t occur in your production build.
      captureError(error);
    });

    this.props.onCatch?.();
  }

  render() {
    if (this.state.hasError) {
      return <InitErrorMessage isModalTheme={this.props.isModalTheme} />;
    }

    return this.props.children;
  }
}
